export function countryCodeToEmoji(countryCode: string): string {
  return String(countryCode)
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

export function countryEmojiToCountryCode(emoji: string): string {
  return String.fromCodePoint(emoji.charCodeAt(1) - 56741) + String.fromCodePoint(emoji.charCodeAt(3) - 56741);
}
